// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Drawer_drawer-container__OiEVB {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  display: flex;
  align-items: flex-start;
  z-index: var(--m-z-index-modal-backdrop);
  background: var(--m-modal-overlay-background-color);
  overflow: auto;
  animation: Drawer_fadeIn__SRtep 0.4s;
  color: var(--m-text);
}
.Drawer_drawer-container--right__EzM7W {
  justify-content: flex-end;
}
.Drawer_drawer-container--left__NbLTQ {
  justify-content: flex-start;
}
.Drawer_drawer-container--top__HyIGe {
  justify-content: center;
}
.Drawer_drawer-container--bottom__b6qmJ {
  justify-content: center;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__\\+pqu8 {
  background-color: var(--m-card-background-color);
  color: var(--m-text);
  display: flex;
  flex-direction: column;
  outline: 0px;
  pointer-events: auto;
  border: 1px solid transparent;
  z-index: var(--m-z-index-modal);
  height: 100%;
  min-width: 350px;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content--scroll-inside__STxKD {
  height: auto;
  max-height: 100%;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content--scroll-inside__STxKD .Drawer_body__JJr2J {
  height: auto;
  overflow: auto;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__header__xbg9I {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  z-index: 1;
  padding: 16px 24px;
  box-shadow: none;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__header--title__rA6fa {
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__header--close__pg7XQ {
  padding: 4px;
  cursor: pointer;
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__header--close__pg7XQ:hover {
  background-color: var(--m-subtle);
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__header--border-bottom__d2Jk- {
  border-bottom: 2px solid var(--m-subtle-bolder);
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__\\+pqu8 .Drawer_body__JJr2J {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 8px 24px;
  overflow-x: hidden !important;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__\\+pqu8 .Drawer_footer-drawer__UrbB4 {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 16px;
  position: relative;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__\\+pqu8 .Drawer_footer-drawer__buttons__szJq0 {
  display: flex;
  align-items: center;
  gap: 10px;
}
.Drawer_drawer-container__OiEVB .Drawer_drawer-content__\\+pqu8 .Drawer_footer-drawer--border-top__XUNUt {
  border-top: 2px solid var(--m-subtle-bolder);
}
@keyframes Drawer_fadeIn__SRtep {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Drawer/Drawer.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACG,MAAA;EACH,OAAA;EACA,QAAA;EACA,eAAA;EACG,aAAA;EACA,uBAAA;EACA,wCAAA;EACA,mDAAA;EACA,cAAA;EAEA,oCAAA;EACA,oBAAA;AACJ;AACI;EACI,yBAAA;AACR;AAEI;EACI,2BAAA;AAAR;AAGI;EACI,uBAAA;AADR;AAII;EACI,uBAAA;AAFR;AAKI;EACI,gDAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,6BAAA;EACN,+BAAA;EACM,YAAA;EACA,gBAAA;AAHR;AAMQ;EACI,YAAA;EACA,gBAAA;AAJZ;AAMY;EACI,YAAA;EACA,cAAA;AAJhB;AAQQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AANZ;AAQY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AANhB;AASY;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAPhB;AASgB;EACI,iCAAA;AAPpB;AAWY;EACI,+CAAA;AAThB;AAaQ;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;AAXZ;AAcQ;EACI,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AAZZ;AAcY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAZhB;AAeY;EACI,4CAAA;AAbhB;AA4BA;EACI;IACI,UAAA;EAjBN;EAoBE;IACI,UAAA;EAlBN;AACF","sourcesContent":[".drawer-container {\n\twidth: 100%;\n\theight: 100%;\n    top: 0;\n\tleft: 0;\n\tright: 0;\n\tposition: fixed;\n    display: flex;\n    align-items: flex-start;\n    z-index: var(--m-z-index-modal-backdrop);\n    background: var(--m-modal-overlay-background-color);\n    overflow: auto;\n    -webkit-animation: fadeIn .4s;\n    animation: fadeIn .4s;\n    color: var(--m-text);\n\n    &--right {\n        justify-content: flex-end;\n    }\n\n    &--left {\n        justify-content: flex-start;\n    }\n\n    &--top {\n        justify-content: center;\n    }\n\n    &--bottom {\n        justify-content: center;\n    }\n\n    .drawer-content {\n        background-color: var(--m-card-background-color);\n        color: var(--m-text);\n        display: flex;\n        flex-direction: column;\n        outline: 0px;\n        pointer-events: auto;\n        border: 1px solid transparent;\n\t\tz-index: var(--m-z-index-modal);\n        height: 100%;\n        min-width: 350px;\n\n\n        &--scroll-inside {\n            height: auto;\n            max-height: 100%;\n\n            .body {\n                height: auto;\n                overflow: auto;\n            }\n        }\n\n        &__header {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            flex: 0 0 auto;\n            z-index: 1;\n            padding: 16px 24px;\n            box-shadow: none;\n\n            &--title {\n                font-weight: 500;\n                font-size: 18px;\n                line-height: 20px;\n            }\n            \n            &--close {\n                padding: 4px;\n                cursor: pointer;\n                position: relative;\n                width: 30px;\n                height: 30px;\n                border-radius: 4px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 20px;\n\n                &:hover {\n                    background-color: var(--m-subtle);\n                }\n            }\n            \n            &--border-bottom {\n                border-bottom: 2px solid var(--m-subtle-bolder);\n            }\n        }\n\n        .body {\n            display: flex;\n            flex: 1 1 auto;\n            flex-direction: column;\n            padding: 8px 24px;\n            overflow-x: hidden !important;\n        }\n        \n        .footer-drawer {\n            display: flex;\n            align-items: flex-end;\n            justify-content: flex-end;\n            padding: 16px;\n            position: relative;\n\n            &__buttons {\n                display: flex;\n                align-items: center;\n                gap: 10px;\n            }\n\n            &--border-top {\n                border-top: 2px solid var(--m-subtle-bolder);\n            }\n        }\n    }\n}\n\n@-webkit-keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    \n    to {\n        opacity: 1;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer-container": `Drawer_drawer-container__OiEVB`,
	"fadeIn": `Drawer_fadeIn__SRtep`,
	"drawer-container--right": `Drawer_drawer-container--right__EzM7W`,
	"drawer-container--left": `Drawer_drawer-container--left__NbLTQ`,
	"drawer-container--top": `Drawer_drawer-container--top__HyIGe`,
	"drawer-container--bottom": `Drawer_drawer-container--bottom__b6qmJ`,
	"drawer-content": `Drawer_drawer-content__+pqu8`,
	"drawer-content--scroll-inside": `Drawer_drawer-content--scroll-inside__STxKD`,
	"body": `Drawer_body__JJr2J`,
	"drawer-content__header": `Drawer_drawer-content__header__xbg9I`,
	"drawer-content__header--title": `Drawer_drawer-content__header--title__rA6fa`,
	"drawer-content__header--close": `Drawer_drawer-content__header--close__pg7XQ`,
	"drawer-content__header--border-bottom": `Drawer_drawer-content__header--border-bottom__d2Jk-`,
	"footer-drawer": `Drawer_footer-drawer__UrbB4`,
	"footer-drawer__buttons": `Drawer_footer-drawer__buttons__szJq0`,
	"footer-drawer--border-top": `Drawer_footer-drawer--border-top__XUNUt`
};
export default ___CSS_LOADER_EXPORT___;
